import _ from 'underscore';
import Backbone from 'backbone';

import CoreModel from 'core/models/core';


export default CoreModel.extend({
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'activity',
  }),

  parse: function (obj, resp) {
    return obj;
  },

  get_goal: function (activity_goal_collection) {
    return activity_goal_collection.findWhere({
      activity: this.get('resource_uri')
    });
  },

  get_group: function (activity_group_collection) {
    return activity_group_collection.findWhere({
      resource_uri: this.get('group')
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/models/activity.js